import {
  HStack,
  Link,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

const tabStyle = {
  fontWeight: 'bold',
  backgroundColor: 'transparent',
  borderBottom: '4px solid',
  borderColor: 'transparent',
  color: 'gray.600',
  marginBottom: '-4px!important',
  paddingTop: 3,
  paddingBottom: 3,
  paddingLeft: 3,
  paddingRight: 3,
  height: 'auto',
  fontSize: '15px',
  lineHeight: '1.5',
  transition: 'all 0.2s ease-in-out',
  borderRadius: 0,
  _focus: {
    boxShadow: 'none',
  },
  _hover: {
    background: 'gray.100',
  },
};

const activeTabStyle = {
  ...tabStyle,
  borderColor: 'brand.orange.500',
  color: 'gray.800',
  outline: 'none',
  _hover: {
    background: 'transparent',
    cursor: 'default',
  },
};

export default function TabbedSubnav({ tabs, ...rest }) {
  const currentUrl = window.location.pathname.split('/').pop();

  return (
    <HStack
      borderBottom="4px solid"
      borderColor="gray.100"
      spacing={2}
      {...rest}
    >
      {tabs
        .map((tab) => (
          <Link
            key={tab.path}
            variant="unstyled"
            as={RouterLink}
            to={tab.path}
            sx={currentUrl === tab.path ? activeTabStyle : tabStyle}
          >
            {tab.label}
          </Link>
        ))}
    </HStack>
  );
}
